import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { Calendar } from '../../../components-v2/Calendar';
import { THEME } from '../../../components-v2/Theme/theme';
import { IDueDateValue, moveDueDateToDay } from '../utils/buckets';
import { getSnoozeOptions, snoozeTo } from '../utils/snooze';

interface IProps {
	current: IDueDateValue;
	onSelect: (value: IDueDateValue) => void;
}

export const SnoozeMenu: React.FC<IProps> = ({ current, onSelect }) => {
	const [picking, setPicking] = React.useState(false);
	const options = getSnoozeOptions(current);
	const selectedDay = current.dueDate ? new Date(current.dueDate) : undefined;

	if (picking) {
		return (
			<div className={css(styleSheet.container)} data-testid='snooze-menu'>
				<Calendar
					mode='single'
					selected={selectedDay}
					defaultMonth={selectedDay}
					onSelect={day => {
						if (day) {
							onSelect(moveDueDateToDay(day, current));
						}
					}}
				/>
				<Button variant='ghost' size='sm' onClick={() => setPicking(false)}>
					Back
				</Button>
			</div>
		);
	}

	return (
		<div className={css(styleSheet.container)} data-testid='snooze-menu' role='menu'>
			{options.map(option => (
				<Button
					key={option.id}
					variant='ghost'
					size='sm'
					role='menuitem'
					styles={[styleSheet.option, option.id === 'clear' && styleSheet.clearOption]}
					onClick={() => onSelect(snoozeTo(option.id, current))}
				>
					{option.label}
				</Button>
			))}
			<Button variant='ghost' size='sm' role='menuitem' styles={[styleSheet.option]} onClick={() => setPicking(true)}>
				Pick a date…
			</Button>
		</div>
	);
};

const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		minWidth: 180,
	},
	option: {
		justifyContent: 'flex-start',
	},
	clearOption: {
		color: THEME.colors.danger.dark,
	},
});
